import { getData } from '../../axiosServices'

export const getLabWiseModulePractice = (coeId,labId,makerplanId) => {
    const url = `reports/coe/${coeId}/lab/${labId}/makerplan/${makerplanId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const getLabWiseTopicPractice = (coeId,labType,makerplanId,moduleID,labId) => {
    const url = `reports/coe/${coeId}/labtype/${labType}/makerplan/${makerplanId}/module/${moduleID}?labid=${labId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const getLabsByLabtype = (coeId,labType,makerplanId) => {
    const url = `makerplans/${makerplanId}/coe/${coeId}/labtype/${labType}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};

